import * as validate from './validate'
import * as helper from './helper'
import * as date from './date'
import store from '@/store'
import { CartService, EnvService, ProductService, TrackingService } from '@/services'
import { cloneDeep, isArray, isPlainObject } from 'lodash'
import { LOCAL_CART, ADD_TIMING_ID, AD_USER_ID, ADCD } from '@/constants'
import { ENV_KEY } from '@/constants/env'
import liff from '@line/liff'

export default { validate, helper, date }

export const initEnv = () => EnvService.getEnv().then((data) => store.commit('env/SET_ENV', data))

export const syncCart = async () => {
  const user = store.getters['auth/user']

  if (user && user.id) {
    const tmpCarts = store.state.cart.carts
      .filter((i) => !i.cart_item_id && !i.is_out_stock)
      .map((i) =>
        Object.assign({
          product_sku_id: i.id,
          quantity: i.quantity,
          subscription: i.subscription,
          sale_limit: i.sale_limit,
        })
      )

    await CartService.syncCarts(tmpCarts)
    const [{ data: normalData }, { data: subscriptionData }] = await Promise.all([
      CartService.getCart(0),
      CartService.getCart(1),
    ])

    const [normalCarts, subscriptionCarts] = await Promise.all([
      syncCartItem(normalData, false),
      syncCartItem(subscriptionData, true),
    ])

    store.commit('cart/SET_CART', [...normalCarts, ...subscriptionCarts])
    localStorage.removeItem(LOCAL_CART)
  }
}

const syncCartItem = async (beData, subscription) => {
  const user = store.getters['auth/user']
  const ids = beData.map((i) => i.product_sku?.id + ':' + i.quantity).filter(Boolean)

  if (ids.length) {
    const { data } = await ProductService.getProductSku({
      product_sku_ids: ids.join(),
      is_subscription: Number(subscription),
      customer_id: user && user.id,
    })

    const cartsToSync = beData.map((i) => {
      const sku_item_be = data.items.find((j) => j.id === i.product_sku?.id)

      return Object.assign({
        quantity: i.quantity,
        sale_type: i.product_sku.product.sale_type,
        cart_item_id: i.cart_item_id,
        subscription: Number(subscription),
        is_product_sku_valid: i.is_product_sku_valid,
        visible: i.product_sku.visible,
        id: i.product_sku.id,
        product_id: i.product_sku.product.id,
        is_out_stock: i.is_out_stock || true,
        ...sku_item_be,
        product_image: `${store.getters['env/GET_KEY'](ENV_KEY.IMAGE_API)}/${sku_item_be?.product_image}`,
      })
    })
    if (subscription == 0) {
      store.commit('cart/SET_NOMAL_CARTS_SUMMARY', data.summary)
    } else {
      store.commit('cart/SET_SUBSCRIPTION_CARTS_SUMMARY', data.summary)
    }

    return cartsToSync
  }

  return []
}

export const trimForm = (form, excepts = []) => {
  const emptyObj = {}
  if (!form || typeof form === 'number') {
    return form
  } else if (typeof form === 'string') {
    return form.trim()
  } else {
    Object.entries(form).map(([key, value]) => {
      if (isArray(excepts) && excepts.includes(key)) {
        emptyObj[key] = value
      } else if (typeof value === 'string') {
        emptyObj[key] = value.trim()
      } else if (isPlainObject(value)) {
        emptyObj[key] = trimForm(value)
      } else if (isArray(value)) {
        emptyObj[key] = value.map((x) => trimForm(x))
      } else {
        emptyObj[key] = value
      }
    })
    return emptyObj
  }
}

export const trackingAdv = async (adcd, ad_user_id, redirect_uri, code, state, customer_id) => {
  const userId = store.getters['auth/user']?.line_id || (liff.isLoggedIn() && (await liff.getProfile()).userId)

  let params = {
    adcd: adcd || undefined,
    redirect_uri,
    add_timing_id: `${ADD_TIMING_ID}`,
    ad_user_id: ad_user_id || undefined,
    customer_id,
    code,
    state,
  }

  if (!code && !state) {
    params = {
      ...params,
      line_user_id: userId ?? undefined,
    }
  }

  const { data } = await TrackingService.postAdv(params)

  return data
}

export const trackingPermission = async () => {
  const ad_user_id = localStorage.getItem(AD_USER_ID)
  const adcd = localStorage.getItem(ADCD)

  if (ad_user_id && adcd) {
    TrackingService.trackingPermission({
      adcd: adcd,
      ad_user_id: ad_user_id,
      add_timing_id: `${ADD_TIMING_ID}`,
    })
  }
}

export const trimComma = (str) => (typeof str === 'string' ? str.replaceAll(',', '') : str)

export const trimCommaForm = (form, property = ['name01', 'name02', 'addr01', 'addr02', 'addr03']) => {
  const deepForm = cloneDeep(form)
  property.forEach((prop) => (deepForm[prop] = trimComma(deepForm[prop])))

  return deepForm
}

export const toHalfWidth = (val) => val
// .replace(/[！-～]/g, (halfwidthChar) => String.fromCharCode(halfwidthChar.charCodeAt(0) - 0xfee0))
// eslint-disable-next-line no-irregular-whitespace
// .replaceAll('　', ' ')
// .replaceAll('ー', '-')

export const removeIncompatibleCharacters = (value, pattern) => value.replace(pattern, '')

export const changeHalfNumber = (stringNumber) =>
  stringNumber.replace(/[０-９]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xfee0)).replace(/[^0-9]/g, '')

export const isValidPostalCode = ({ postalCode01, postalCode02 }) => {
  const numberPattern = /^[0-9]+$/

  return (
    postalCode01.length === 3 &&
    postalCode02.length === 4 &&
    numberPattern.test(postalCode01) &&
    numberPattern.test(postalCode02)
  )
}

export const isVisibleRankMemberShopDetail = (data) => {
  if (!data) {
    return false
  }
  if (!data.customer_rank_use_flag) {
    return false
  }
  if (!data.customer_rank_operation_start_date) {
    return false
  }

  if (!data.customer_rank_operation_end_date) {
    const dateStart = data.customer_rank_operation_start_date
    const dateNow = Date.now()

    if (dateStart <= dateNow) {
      return true
    } else {
      return false
    }
  } else {
    const dateStart = data.customer_rank_operation_start_date
    const dateEnd = data.customer_rank_operation_end_date
    const dateNow = Date.now()

    if (dateStart <= dateNow && dateNow < dateEnd) {
      return true
    } else {
      return false
    }
  }
}

export const syncSubscriptionItems = async (deliveryFeeRequestFlag = false) => {
  const user = store.getters['auth/user']
  const tmpSubscription = store.state.subscription.subscription
  const tmpSubsOrderItem = tmpSubscription.subscription_order_item || []
  const ids = tmpSubsOrderItem.map((i) => i.product_sku_id + ':' + i.quantity).filter(Boolean)

  if (ids.length) {
    let params = {
      product_sku_ids: ids.join(),
      is_subscription: 1,
      customer_id: user && user.id,
      delivery_method_id: tmpSubscription.delivery_id,
      subscription_id: tmpSubscription.id,
    }

    if (deliveryFeeRequestFlag) {
      params = {
        ...params,
        delivery_fee: tmpSubscription.delivery_fee,
      }
    }

    if (tmpSubscription.adjustment_amount !== null) {
      params = {
        ...params,
        adjustment_amount: tmpSubscription.adjustment_amount,
      }
    }

    const { data } = await ProductService.getProductSku(params)

    // 定期更新画面では初回割引の表示は無いので、次回以降の情報を利用して画面を表示する
    const subscriptionToSync = data.items.map((i) => {
      const subsOrderItem = tmpSubsOrderItem.find((j) => j.product_sku_id === i.id)

      return Object.assign({
        quantity: Number(i.quantity),
        price: Number(i.next_price03_after_tax),
        subtotal: Number(i.next_subtotal_price03_after_tax),
        discount_amount: Number(i.discount_amount),
        discount_amount_total: Number(i.next_subtotal_discount_amount),
        lump_sum_payment_flag: i.lump_sum_payment_flag,
        lump_sum_payment_num: i.lump_sum_payment_num,
        tax: Number(i.next_subtotal_tax_price),
        tax_rate: i.tax_rate,
        subscription: Number(i.subscription),
        id: subsOrderItem ? subsOrderItem.id : null,
        product_id: i.product_id,
        product_sku_id: i.id,
        product_name: i.product_name,
        is_out_stock: i.is_out_stock || true,
        sku_item_parent_name_1: i.sku_item_parent_name_1,
        sku_item_parent_name_2: i.sku_item_parent_name_2,
        sku_set_item_name1: i.sku_set_item_name1,
        sku_set_item_name2: i.sku_set_item_name2,
        sale_limit: i.sale_limit,
        product_image: `${store.getters['env/GET_KEY'](ENV_KEY.IMAGE_API)}/${i.product_image}`,
      })
    })

    store.commit('subscription/UPDATE_SUBSCRIPTION', {
      ...tmpSubscription,
      subscription_order_item: subscriptionToSync,
      subtotal: Number(data.summary.next_subtotal),
      payment_total: Number(data.summary.next_payment_total),
      delivery_fee: Number(data.summary.next_delivery_fee),
      discount_amount: Number(data.summary.next_discount_amount_total),
      tax_total: Number(data.summary.next_tax_total),
      summary_status: data.summary.status,
    })

    return subscriptionToSync
  }
  return []
}

export const downloadFile = (res, fileName, type = 'application/pdf') => {
  const blob = new Blob([res.data], { type: type })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')

  a.href = url
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)

  window.URL.revokeObjectURL(url)
}

export const nullish = (variable, ...section) => {
  if (variable !== null && variable !== undefined) {
    return variable
  }

  for (let i = 0; i <= section.length; i++) {
    if (section[i] !== null && section[i] !== undefined) {
      return section[i]
    }
  }

  return ''
}
